import React, { Component } from "react";
import MenuItem from "./menuItem";
import MenuTree from "./menuTree";
import { withRouter } from "react-router-dom";
import { OfflineBoltSharp as OfflineBoltIcon } from "@material-ui/icons";

class Menu extends Component {
    render() {
        const selecionado = this.props.location && this.props.location.pathname ? this.props.location.pathname : "";

        const { sessao } = this.props;

        const outraEmpresa = sessao && sessao.id_empresa === 4;
        const nomeEmpresaAdm = outraEmpresa ? "ADM" : "ADM (Eficience)";

        if (!sessao) return null;

        const acessoCadastroEmpresa = sessao.administrador && !sessao.id_cliente && !sessao.id_empresa;

        const acessoCadastroCliente =
            sessao.acesso_modulo_cliente &&
            !sessao.acesso_cliente &&
            (sessao.acesso_cadastro_cliente_visualizar ||
                sessao.acesso_cadastro_cliente_adicionar ||
                sessao.acesso_cadastro_cliente_editar ||
                sessao.acesso_cadastro_cliente_excluir);

        const acessoCadastroConcessionaria =
            sessao.acesso_modulo_concessionaria &&
            !sessao.acesso_cliente &&
            (sessao.acesso_concessionaria_visualizar || sessao.acesso_concessionaria_adicionar || sessao.acesso_concessionaria_editar || sessao.acesso_concessionaria_excluir);

        const acessoCadastroPlataformaMercadoLivre =
            sessao.acesso_modulo_plataforma_mercado_livre &&
            !sessao.acesso_cliente &&
            (sessao.acesso_plataforma_mercado_livre_adicionar || sessao.acesso_plataforma_mercado_livre_editar);

        const acessoCadastroGestorConcessionaria =
            sessao.acesso_modulo_gestor_concessionaria &&
            !sessao.acesso_cliente &&
            (sessao.acesso_gestor_concessionaria_visualizar ||
                sessao.acesso_gestor_concessionaria_adicionar ||
                sessao.acesso_gestor_concessionaria_editar ||
                sessao.acesso_gestor_concessionaria_excluir);

        const acessoCadastroEmpenho =
            sessao.acesso_modulo_empenho &&
            !sessao.acesso_cliente &&
            !sessao.usuario_implantacao &&
            (sessao.acesso_empenho_visualizar || sessao.acesso_empenho_adicionar || sessao.acesso_empenho_editar || sessao.acesso_empenho_excluir);

        const acessoCadastroDocumento = sessao.acesso_modulo_documento && (sessao.acesso_documento_visualizar || sessao.acesso_documento_editar);

        const acessoCadastroDemandaContrato =
            sessao.acesso_modulo_demanda_contrato &&
            !sessao.acesso_cliente &&
            (sessao.acesso_cadastro_demanda_visualizar ||
                sessao.acesso_cadastro_demanda_adicionar ||
                sessao.acesso_cadastro_demanda_editar ||
                sessao.acesso_cadastro_demanda_excluir);

        const acessoCadastroContratoMercadoLivre =
            sessao.acesso_modulo_contrato_mercado_livre &&
            !sessao.acesso_cliente &&
            (sessao.acesso_contrato_mercado_livre_visualizar ||
                sessao.acesso_contrato_mercado_livre_adicionar ||
                sessao.acesso_contrato_mercado_livre_editar ||
                sessao.acesso_contrato_mercado_livre_excluir);

        const acessoCadastroContratoAluguel =
            sessao.acesso_modulo_contrato_aluguel &&
            !sessao.acesso_cliente &&
            (sessao.acesso_contrato_aluguel_visualizar ||
                sessao.acesso_contrato_aluguel_adicionar ||
                sessao.acesso_contrato_aluguel_editar ||
                sessao.acesso_contrato_aluguel_excluir);

        const acessoCadastroGeracao =
            sessao.acesso_modulo_geracao &&
            !sessao.acesso_cliente &&
            (sessao.acesso_cadastro_geracao_visualizar ||
                sessao.acesso_cadastro_geracao_adicionar ||
                sessao.acesso_cadastro_geracao_editar ||
                sessao.acesso_cadastro_geracao_excluir);

        const acessoCadastroGeracaoIntegracao = sessao.acesso_modulo_geracao_integracao && !sessao.acesso_cliente && (sessao.acesso_solar_visualizar || sessao.acesso_solar_editar);

        const acessoCadastroConsumoIntegracao =
            sessao.acesso_modulo_consumo_integracao && !sessao.acesso_cliente && (sessao.acesso_monitoramento_consumo_visualizar || sessao.acesso_monitoramento_consumo_editar);

        const acessoCadastroRede = sessao.acesso_modulo_rede && !sessao.acesso_cliente && (sessao.acesso_redes_visualizar || sessao.acesso_redes_editar);

        const acessoCadastroTributacao =
            sessao.acesso_modulo_tributacao &&
            !sessao.acesso_cliente &&
            (sessao.acesso_tributacao_visualizar || sessao.acesso_tributacao_adicionar || sessao.acesso_tributacao_editar || sessao.acesso_tributacao_excluir);

        const acessoFaturaAdm =
            sessao.acesso_modulo_fatura && !sessao.acesso_cliente && (sessao.acesso_fatura_visualizar || sessao.acesso_fatura_editar || sessao.acesso_fatura_editar_fechado);

        const acessoGestaoTarefa =
            sessao.acesso_modulo_gestao_tarefa &&
            !sessao.acesso_cliente &&
            (sessao.acesso_gestao_processo_visualizar || sessao.acesso_gestao_processo_adicionar || sessao.acesso_gestao_processo_editar || sessao.acesso_gestao_processo_excluir);

        const acessoDocumentoAdm =
            sessao.acesso_modulo_documento_adm &&
            !sessao.acesso_cliente &&
            (sessao.acesso_documento_adm_visualizar || sessao.acesso_documento_adm_adicionar || sessao.acesso_documento_adm_editar || sessao.acesso_documento_adm_excluir);

        const acessoFaturaEngenharia =
            sessao.acesso_modulo_fatura_engenharia && (sessao.acesso_multa_visualizar || sessao.acesso_multa_editar || sessao.acesso_multa_editar_fechado);

        const acessoVerificadorIcms = sessao.acesso_modulo_verificador_icms_energia && sessao.acesso_icms_energia_visualizar;

        const acessoVerificadorAgua = sessao.acesso_modulo_verificador_consumo_agua && sessao.acesso_consumo_agua_visualizar;

        return (
            <nav className="mt-2">
                <ul className="nav nav-pills nav-sidebar flex-column nav-flat nav-compact" data-widget="treeview" role="menu" data-accordion="false">
                    <MenuItem
                        path="/dashboard"
                        label="Tela Inicial"
                        icon="fas fa-tachometer-alt"
                        active={selecionado === "/dashboard"}
                        permitido={sessao.acesso_modulo_dashboard}
                    />
                    <MenuItem
                        path="/usuario"
                        label="Usuário"
                        icon="fas fa-users"
                        active={selecionado === "/usuario"}
                        permitido={
                            sessao.acesso_modulo_usuario &&
                            (sessao.acesso_usuario_visualizar ||
                                sessao.acesso_usuario_adicionar ||
                                sessao.acesso_usuario_editar ||
                                sessao.acesso_usuario_excluir ||
                                sessao.acesso_usuario_permissao ||
                                sessao.acesso_usuario_permissao_administrador ||
                                sessao.acesso_usuario_editar_administrador ||
                                sessao.acesso_usuario_excluir_administrador)
                        }
                        onClick={() => window.location.reload()}
                    />
                    <MenuTree
                        icon="fas fa-list"
                        label="Cadastros"
                        permitido={
                            acessoCadastroEmpresa ||
                            acessoCadastroCliente ||
                            acessoCadastroConcessionaria ||
                            acessoCadastroPlataformaMercadoLivre ||
                            acessoCadastroGestorConcessionaria ||
                            acessoCadastroEmpenho ||
                            acessoCadastroDocumento ||
                            acessoCadastroDemandaContrato ||
                            acessoCadastroContratoMercadoLivre ||
                            acessoCadastroContratoAluguel ||
                            acessoCadastroGeracao ||
                            acessoCadastroGeracaoIntegracao ||
                            acessoCadastroConsumoIntegracao ||
                            acessoCadastroRede ||
                            acessoCadastroTributacao
                        }
                    >
                        <MenuItem path="/empresa" label="Empresa" icon="fas fa-building" submenu={true} active={selecionado === "/empresa"} permitido={acessoCadastroEmpresa} />
                        <MenuItem path="/cliente" label="Cliente" icon="fas fa-user-circle" submenu={true} active={selecionado === "/cliente"} permitido={acessoCadastroCliente} />
                        <MenuItem
                            path="/concessionaria"
                            label="Concessionária"
                            icon="fas fa-city"
                            submenu={true}
                            active={selecionado === "/concessionaria"}
                            permitido={acessoCadastroConcessionaria}
                        />
                        <MenuItem
                            path="/plataforma-mercado-livre"
                            label="Plataforma de Mercado Livre"
                            icon="fas fa-laptop-house"
                            submenu={true}
                            active={selecionado === "/plataforma-mercado-livre"}
                            permitido={acessoCadastroPlataformaMercadoLivre}
                        />
                        <MenuItem
                            path="/gestor-concessionaria"
                            label="Gestor de Concessionária"
                            icon="fas fa-id-badge"
                            submenu={true}
                            active={selecionado === "/gestor-concessionaria"}
                            permitido={acessoCadastroGestorConcessionaria}
                        />
                        <MenuItem
                            path="/empenho"
                            label="Empenho (prefeituras)"
                            icon="fas fa-money-check-alt"
                            submenu={true}
                            active={selecionado === "/empenho"}
                            permitido={acessoCadastroEmpenho}
                        />

                        <MenuItem
                            path="/documento"
                            label="Anexar Documentos"
                            icon="fas fa-paste"
                            submenu={true}
                            active={selecionado === "/documento"}
                            permitido={acessoCadastroDocumento}
                        />
                        <MenuItem
                            path="/demanda-contrato"
                            label="Contrato de Demanda"
                            icon="fas fa-file-contract"
                            submenu={true}
                            active={selecionado === "/demanda-contrato"}
                            permitido={acessoCadastroDemandaContrato}
                        />
                        <MenuItem
                            path="/contrato-mercado-livre"
                            label="Contrato de Mercado Livre"
                            icon="fas fa-store"
                            submenu={true}
                            active={selecionado === "/contrato-mercado-livre"}
                            permitido={acessoCadastroContratoMercadoLivre}
                        />
                        <MenuItem
                            path="/contrato-aluguel"
                            label="Contrato de Aluguel de Usina"
                            icon="fas fa-handshake"
                            submenu={true}
                            active={selecionado === "/contrato-aluguel"}
                            permitido={acessoCadastroContratoAluguel}
                        />
                        <MenuItem
                            path="/geracao"
                            label="Micro e Mini Gerador"
                            icon="fas fa-solar-panel"
                            submenu={true}
                            active={selecionado === "/geracao"}
                            permitido={acessoCadastroGeracao}
                        />
                        <MenuItem
                            path="/geracao-integracao"
                            label="Integração Geração"
                            icon="fas fa-sun"
                            submenu={true}
                            active={selecionado === "/geracao-integracao"}
                            permitido={acessoCadastroGeracaoIntegracao}
                        />
                        <MenuItem
                            path="/consumo-integracao"
                            label="Integração Consumo"
                            icon="fas fa-lightbulb"
                            submenu={true}
                            active={selecionado === "/consumo-integracao"}
                            permitido={acessoCadastroConsumoIntegracao}
                        />
                        <MenuItem path="/rede" label="Rede Elétrica" icon="fas fa-network-wired" submenu={true} active={selecionado === "/rede"} permitido={acessoCadastroRede} />
                        <MenuItem
                            path="/tributacao"
                            title="(Cadastro de %ICMS por estado e por atividade)"
                            label="Tributação"
                            icon="fas fa-percentage"
                            submenu={true}
                            marginRight={7}
                            marginLeft={23}
                            active={selecionado === "/tributacao"}
                            permitido={acessoCadastroTributacao}
                        />
                    </MenuTree>
                    <MenuTree icon="fas fa-user-lock" label={nomeEmpresaAdm} permitido={acessoFaturaAdm || acessoGestaoTarefa || acessoDocumentoAdm}>
                        <MenuItem
                            path="/fatura"
                            title="(Gestão de Importação)"
                            label="Faturas ADM"
                            muiIcon={<OfflineBoltIcon fontSize="inherit" />}
                            submenu={true}
                            marginRight={7}
                            marginLeft={23}
                            active={selecionado === "/fatura"}
                            permitido={acessoFaturaAdm}
                        />
                        <MenuItem
                            path="/gestao-tarefa"
                            title="(Gestão de Tarefas)"
                            label="Gestão de Tarefas"
                            icon="fas fa-tasks"
                            submenu={true}
                            active={selecionado === "/gestao-tarefa"}
                            permitido={acessoGestaoTarefa}
                        />
                        <MenuItem
                            path="/documento-adm"
                            label="Documentos Eficience"
                            icon="fas fa-paste"
                            submenu={true}
                            active={selecionado === "/documento-adm"}
                            permitido={acessoDocumentoAdm}
                        />
                    </MenuTree>

                    <MenuItem
                        path="/fatura-cliente"
                        title="(Visualizar e/ou Baixar)"
                        label="Faturas"
                        icon="fas fa-bolt"
                        marginRight={3}
                        marginLeft={12}
                        active={selecionado === "/fatura-cliente"}
                        permitido={sessao.acesso_modulo_fatura_cliente && (sessao.acesso_fatura_visualizar || sessao.acesso_fatura_editar || sessao.acesso_fatura_editar_fechado)}
                    />
                    <MenuTree
                        icon="fas fa-search-dollar"
                        label="Verificador de Faturas"
                        title="Identifica e ilustra custos indesejáveis que podem estar presentes em faturas de energia e água"
                        permitido={acessoFaturaEngenharia || acessoVerificadorIcms || acessoVerificadorAgua}
                    >
                        <MenuItem
                            title="Identifica e ilustra a existência de multa nas faturas de energia elétrica"
                            path="/fatura-engenharia"
                            label="Identificador de Multas (Energia)"
                            icon="fas fa-file-invoice-dollar"
                            submenu={true}
                            marginLeft={12}
                            active={selecionado === "/fatura-engenharia"}
                            permitido={acessoFaturaEngenharia}
                        />
                        <MenuItem
                            title="Identifica e ilustra a existência de erros de cobrança de ICMS em faturas de energia elétrica conforme cadastro"
                            path="/verificador-icms-energia"
                            label="Verificador de ICMS e Subsídio de Irrigantes (Energia)"
                            icon="fas fa-hand-holding-usd"
                            submenu={true}
                            marginLeft={12}
                            active={selecionado === "/verificador-icms-energia"}
                            permitido={acessoVerificadorIcms}
                        />
                        <MenuItem
                            title="Identifica e ilustra faturas de água com chance de possuir vazamentos e consumos muito acima da média esperada"
                            path="/verificador-consumo-agua"
                            label="Verificador de consumo (Água)"
                            icon="fas fa-faucet"
                            submenu={true}
                            marginLeft={12}
                            active={selecionado === "/verificador-consumo-agua"}
                            permitido={acessoVerificadorAgua}
                        />
                    </MenuTree>
                    <MenuItem
                        path="/fatura-relatorio"
                        label="Relatório"
                        icon="fas fa-file-pdf"
                        marginLeft={15}
                        active={selecionado === "/fatura-relatorio"}
                        permitido={sessao.acesso_modulo_fatura_relatorio && sessao.acesso_relatorio}
                    />
                    <MenuItem
                        path="/analise"
                        label="Análise"
                        icon="fas fa-chart-line"
                        marginLeft={15}
                        active={selecionado === "/analise"}
                        permitido={sessao.acesso_modulo_analise && sessao.acesso_analise}
                    />
                    <MenuItem
                        path="/gestao-credito-solar"
                        label="Gestão de Crédito Solar"
                        icon="fas fa-coins"
                        marginLeft={15}
                        active={selecionado === "/gestao-credito-solar"}
                        permitido={sessao.acesso_gestao_credito_solar_visualizar && sessao.acesso_modulo_gestao_credito_solar}
                    />
                    <MenuItem
                        path="/diagnostico-energia"
                        label="Diagnóstico de Energia"
                        icon="fas fa-funnel-dollar"
                        marginLeft={15}
                        active={selecionado === "/diagnostico-energia"}
                        permitido={sessao.acesso_diagnostico_energia_visualizar && sessao.acesso_modulo_diagnostico_energia}
                    />
                    <MenuItem
                        path="/redes-eletricas"
                        label="Redes Elétricas"
                        icon="fas fa-network-wired"
                        marginRight={7}
                        marginLeft={12}
                        active={selecionado === "/redes-eletricas"}
                        permitido={sessao.acesso_modulo_redes_eletricas && sessao.acesso_redes_visualizar}
                    />
                    <MenuItem
                        path="/documento-cliente"
                        label="Documentos do Cliente"
                        icon="fas fa-paste"
                        marginLeft={15}
                        active={selecionado === "/documento-cliente"}
                        permitido={sessao.acesso_modulo_documento_cliente && (sessao.acesso_documento_visualizar || sessao.acesso_documento_editar)}
                    />
                    <MenuItem
                        path="/monitoramento-solar"
                        label="Monitoramento Solar"
                        icon="fas fa-sun"
                        marginLeft={14}
                        active={selecionado === "/monitoramento-solar"}
                        permitido={sessao.acesso_modulo_geracao_leitura && (sessao.acesso_solar_visualizar || sessao.acesso_solar_editar)}
                    />
                    <MenuItem
                        path="/monitoramento-consumo"
                        label="Monitoramento de Consumo"
                        icon="fas fa-lightbulb"
                        marginLeft={14}
                        active={selecionado === "/monitoramento-consumo"}
                        permitido={sessao.acesso_modulo_monitoramento_consumo && (sessao.acesso_monitoramento_consumo_visualizar || sessao.acesso_monitoramento_consumo_editar)}
                    />
                </ul>
            </nav>
        );
    }
}

export default withRouter(Menu);
